const Builder = require('../BuilderBase');
const DateTimeColumn = require('../listColumns/DateTimeColumn');
const EmbeddedListColumn = require('../listColumns/EmbeddedListColumn');
const ForeignRelationTextColumn = require('../listColumns/ForeignRelationTextColumn');
const LineBreakColumn = require('../listColumns/LineBreakColumn');
const LocalVerboseDateTimeColumn = require('../listColumns/LocalVerboseDateTimeColumn');
const MappedBooleanColumn = require('../listColumns/MappedBooleanColumn');
const NestedDetail = require('../listColumns/NestedDetail');
const TextColumn = require('../listColumns/TextColumn');
const filters = require('../filters');
const { LinkColumn } = require('../listColumns');

module.exports = class TableList extends Builder {
    constructor(title, properties) {
        super('list_TableList', title, properties);
    }

    dateTime(title, properties) {
        const dateTimeColumn = new DateTimeColumn(title, properties);
        this.addChildBlock(dateTimeColumn, 'columns');
        return dateTimeColumn;
    }

    foreignRelationText(title, properties) {
        const foreignRelationTextColumn = new ForeignRelationTextColumn(title, properties);
        this.addChildBlock(foreignRelationTextColumn, 'columns');
        return foreignRelationTextColumn;
    }

    localVerboseDateTime(title, properties) {
        const localVerboseDateTimeColumn = new LocalVerboseDateTimeColumn(title, properties);
        this.addChildBlock(localVerboseDateTimeColumn, 'columns');
        return localVerboseDateTimeColumn;
    }

    mappedBoolean(title, properties) {
        const mappedBooleanColumn = new MappedBooleanColumn(title, properties);
        this.addChildBlock(mappedBooleanColumn, 'columns');
        return mappedBooleanColumn;
    }

    text(title, properties) {
        const textColumn = new TextColumn(title, properties);
        this.addChildBlock(textColumn, 'columns');
        return textColumn;
    }

    filter(type, properties) {
        const Filter = filters[type];
        const filter = new Filter(properties);
        this.addChildBlock(filter, 'filters');
        return filter;
    }

    nestedDetail(title, properties) {
        const nestedDetail = new NestedDetail(title, properties);
        this.addChildBlock(nestedDetail, 'columns');
        return nestedDetail;
    }

    link(title, properties) {
        const obj = new LinkColumn(title, properties);
        this.addChildBlock(obj, 'columns');
        return obj;
    }

    lineBreak(title, properties) {
        const lineBreak = new LineBreakColumn(title, properties);
        this.addChildBlock(lineBreak, 'columns');
        return lineBreak;
    }

    embeddedList(title, properties) {
        const embeddedList = new EmbeddedListColumn(title, properties);
        this.addChildBlock(embeddedList, 'columns');
        return embeddedList;
    }
};
